import {MobCard} from "./MobCard";
import {DynamicIcon} from "lucide-react/dynamic";
import MobPressable from "./MobPressable";
import AppService from "../../services/AppService";
import { useEffect, useRef } from 'react';
import {useNavigate} from "react-router-shim";
import { usePageCache } from './PageCache';

export function MobHeader({title,hasGoBack,goBackUrl,goBackTitle,right,alignLeft})
{
    const navigate=useNavigate();
    const pageCache=usePageCache()
    const backListener=useRef(null)

    const searchParams=new URLSearchParams(window.location.search);

    let _goBackUrl=null
    let _goBackTitle=null

    if(hasGoBack){
        _goBackUrl=-1
    }
    if(goBackUrl){
        _goBackUrl=goBackUrl
    }

    if(goBackTitle){
        _goBackTitle=goBackTitle
    }

    if(searchParams.has("mobHeaderTitle")){
        title=searchParams.get("mobHeaderTitle")
    }

    if(searchParams.has("goBackTitle")){
        _goBackTitle=searchParams.get("goBackTitle")
    }
    if(searchParams.has("goBackUrl")){
        _goBackUrl=searchParams.get("goBackUrl")
    }

    const onGoBack=()=>{
        if (_goBackUrl) {
            pageCache.deleteCachePage()
            if(_goBackUrl===-1){
                navigate(-1)
            }else{
                navigate(_goBackUrl)
            }
        }
    }


    useEffect(() => {
        AppService.setNavigationGesture(false)
        backListener.current=AppService.addEventListener("android.backhandler", () => {
            onGoBack()
        })

        return ()=>{
            AppService.setNavigationGesture(false)
            backListener.current.remove && backListener.current.remove()
        }
    }, [_goBackUrl]);

    return(
        <div style={{display: "flex", flexDirection: "row", alignItems: "center",justifyContent:"space-between",gap:5,maxHeight:80,nHeight:50,marginBottom:10}}>

            {!alignLeft && (
                <div style={{display: "flex", justifyContent: "flex-start", width: "20%"}}>
                    {_goBackUrl !== null && (
                        <MobPressable style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: 5,
                            fontSize: 18,
                            color: "#333"
                        }} onClick={() => {
                            onGoBack()
                        }}>
                            <DynamicIcon name={"chevron-left"} color="#333" size={_goBackTitle ? 24 : 26}/>
                                {_goBackTitle !== null && (
                                    <span>{_goBackTitle}</span>
                                )}
                        </MobPressable>
                    )}
                </div>
            )}


            <div style={{
                display: "flex",
                flexDirection: "column",
                width: _goBackUrl !== null ? "60%" : "80%",
                alignItems: alignLeft?"flex-start":"center",
                justifyContent:"center",
                textAlign: alignLeft?"left":"center"
            }}>
                <span style={{fontWeight: "bold", fontSize: 16, color: "#000"}}>{title}</span>
                {searchParams.has("contactName") && (
                    <span style={{
                        fontWeight: "bold",
                        fontSize: 12,
                        color: "#000"
                    }}>{searchParams.get("contactName")}</span>
                )}
                {searchParams.has("entityName") && (
                    <span style={{
                        fontWeight: "bold",
                        fontSize: 12,
                        color: "#000"
                    }}>{searchParams.get("entityName")}</span>
                )}
            </div>


            <div style={{display:"flex",justifyContent:"flex-end",width:"20%"}}>
                {right}
            </div>

        </div>
    )
}
